import React from 'react'
import PropTypes from 'prop-types'

function CTA({ children, type, className, onClick }) {
  return (
    <button className="CTA" type="button" {...{ type, className, onClick }}>
      {children}
    </button>
  )
}

CTA.defaultProps = {
  children: '',
  type: 'button',
  className: '',
  onClick: null,
}

CTA.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default CTA
